import React, { useState } from "react";
import SupportImage from "../assets/CompanyServices.png";
import elevatorImg from "../assets/elevator.jpg";
import esclarator from "../assets/eeeeee.jpg";
import counter from "../assets/counter.jpg";
import textile from "../assets/textile.jpg";
import solar from "../assets/solar.jpg";
import aayurvedic from "../assets/aayurvedic.jpg";
import realSttae from "../assets/realSttae.jpg";
import far from "../assets/far.jpg";
import industory from "../assets/industry.jpg";

import { motion, AnimatePresence } from "framer-motion";
import { FaChevronDown, FaBuilding, FaArrowRight, FaCheckCircle, FaIndustry } from "react-icons/fa";
import { Link } from "react-router-dom";
import SEO from "../layout/SEO";

const tilesData = [
  {
    title: "Elevators",
    img: elevatorImg,
    content:
      "We specialize in advanced elevator solutions designed for safety, efficiency, and seamless vertical transportation. Whether for commercial, residential, or industrial use, our elevators are built to meet the highest standards of quality and innovation.",
  },
  {
    title: "Escalators",
    img: esclarator,
    content:
      "We provide modern escalator solutions that combine functionality, safety, and aesthetic appeal. Whether upgrading an existing facility or planning a new project, our escalators add value through innovative design, low maintenance costs, and reliable performance.",
  },
  {
    title: "Counter & Design Manufacturing",
    img: counter,
    content:
      "We provide custom counter and design manufacturing services for various industries. Our design-focused manufacturing process ensures that each counter is structurally sound and visually impactful. We work with premium materials including wood, glass, steel, and stone.",
  },
  {
    title: "Textile Manufacturing",
    img: textile,
    content:
      "Our textile manufacturing process integrates advanced machinery with skilled workmanship to produce a wide range of fabrics—woven, knitted, dyed, printed, or finished to exact client specifications. We maintain strict quality control at each stage.",
  },
  {
    title: "Solar Management",
    img: solar,
    content:
      "Our advanced solar management platform continuously monitors energy production and usage, identifying inefficiencies and enabling smart load balancing. With remote diagnostics and detailed analytics, clients gain full control over their energy systems.",
  },
  {
    title: "Ayurvedic Medicine Manufacturing",
    img: aayurvedic,
    content:
      "Rooted in India's rich Ayurvedic heritage, our process integrates traditional formulations with state-of-the-art technology. Each batch is prepared in controlled environments to preserve the efficacy and therapeutic value of the herbs.",
  },
  {
    title: "Real Estate",
    img: realSttae,
    content:
      "Our commercial real estate offerings include office buildings, retail outlets, and business parks. Designed to support modern business needs, our spaces feature strategic locations, scalable layouts, and robust infrastructure.",
  },
  {
    title: "Pharmacy Management",
    img: far,
    content:
      "We ensure that all pharmacy operations comply with healthcare regulations including prescription verification and controlled substance management. Our systems support audit trails and reporting for inspections and accreditation.",
  },
];

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
      delayChildren: 0.2,
    },
  },
};

const itemVariants = {
  hidden: { y: 30, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    transition: { duration: 0.5, ease: "easeOut" },
  },
};

const About = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const toggleTile = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <motion.section
      className="relative bg-cover bg-center bg-no-repeat min-h-screen"
      style={{ backgroundImage: `url(${industory})` }}
      initial="hidden"
      animate="visible"
      variants={containerVariants}
    >
      <SEO
        title="Industries - vTecherpSoftware"
        description="Explore the industries we serve - Elevators, Escalators, Textile, Solar, Real Estate, Pharmacy and more."
        // canonical="https://sapeagleerp.com/industories"
      />

      <div className="absolute inset-0 bg-white/70" />

      <div className="relative z-10 py-16 px-4 sm:px-6 lg:px-8">
        {/* Hero Section */}
        <motion.div
          className="text-center mb-16"
          variants={itemVariants}
        >
          <motion.div
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.6 }}
            className="inline-flex items-center justify-center w-24 h-24 bg-gradient-to-br from-blue-500 to-blue-700 rounded-2xl mb-6 shadow-lg"
          >
            <FaIndustry className="text-white w-10 h-10" />
          </motion.div>
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 relative inline-block">
            Industries We Serve
            <motion.span
              className="block w-24 h-1.5 bg-gradient-to-r from-blue-500 to-blue-700 mx-auto mt-4 rounded-full"
              initial={{ width: 0 }}
              animate={{ width: 96 }}
              transition={{ duration: 0.8, delay: 0.3 }}
            />
          </h2>
          <p className="mt-4 text-lg text-gray-600 max-w-2xl mx-auto">
            Delivering comprehensive ERP solutions across diverse industries with specialized features and tailored implementations.
          </p>
        </motion.div>

        {/* Industry Tiles */}
        <motion.div
          className="max-w-5xl mx-auto space-y-4"
          variants={containerVariants}
        >
          {tilesData.map((tile, index) => {
            const isActive = activeIndex === index;
            return (
              <motion.div
                key={index}
                layout
                variants={itemVariants}
                className={`bg-white rounded-2xl shadow-md cursor-pointer transition-all duration-300 ${
                  isActive ? "shadow-2xl ring-2 ring-blue-500" : "hover:shadow-lg"
                }`}
                onClick={() => toggleTile(index)}
                whileHover={{ scale: 1.01 }}
                whileTap={{ scale: 0.99 }}
              >
                <div className="flex justify-between items-center px-6 py-5 bg-gradient-to-r from-white to-gray-50 rounded-t-2xl">
                  <div className="flex items-center gap-4">
                    <div className={`w-14 h-14 rounded-xl flex items-center justify-center ${
                      isActive ? "bg-blue-600" : "bg-gray-200"
                    }`}>
                      <span className={`text-lg font-bold ${isActive ? "text-white" : "text-gray-600"}`}>
                        {index + 1}
                      </span>
                    </div>
                    <h3 className="text-xl font-bold text-gray-800">{tile.title}</h3>
                  </div>
                  <motion.div
                    animate={{ rotate: isActive ? 180 : 0 }}
                    transition={{ duration: 0.3 }}
                    className={`p-3 rounded-full ${isActive ? "bg-blue-600" : "bg-gray-200"}`}
                  >
                    <FaChevronDown className={`${isActive ? "text-white" : "text-gray-600"} w-4 h-4`} />
                  </motion.div>
                </div>

                <AnimatePresence>
                  {isActive && (
                    <motion.div
                      key="content"
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.4, ease: "easeInOut" }}
                      className="overflow-hidden"
                    >
                      <div className="px-6 pb-6 pt-2">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-center">
                          <motion.p
                            initial={{ x: -20, opacity: 0 }}
                            animate={{ x: 0, opacity: 1 }}
                            transition={{ delay: 0.2 }}
                            className="text-gray-700 leading-relaxed text-lg"
                          >
                            {tile.content}
                          </motion.p>
                          <motion.div
                            initial={{ x: 20, opacity: 0, scale: 0.95 }}
                            animate={{ x: 0, opacity: 1, scale: 1 }}
                            transition={{ delay: 0.3 }}
                            className="relative group"
                          >
                            <div className="absolute inset-0 bg-gradient-to-t from-blue-600/20 to-transparent rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                            <img
                              src={tile.img}
                              alt={tile.title}
                              className="rounded-xl shadow-lg w-full h-56 md:h-64 object-cover transform group-hover:scale-[1.02] transition-transform duration-500"
                            />
                          </motion.div>
                        </div>
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </motion.div>
            );
          })}
        </motion.div>

        {/* Company Section */}
        <motion.div className="mt-24" variants={itemVariants}>
          <motion.div className="text-center mb-12" variants={itemVariants}>
            <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 relative inline-block">
              About Our Company
              <motion.span
                className="block w-24 h-1.5 bg-gradient-to-r from-green-500 to-green-700 mx-auto mt-4 rounded-full"
                initial={{ width: 0 }}
                animate={{ width: 96 }}
                transition={{ duration: 0.8, delay: 0.3 }}
              />
            </h2>
          </motion.div>

          <div className="max-w-6xl mx-auto">
            <motion.div
              className="bg-white rounded-3xl shadow-2xl border border-gray-100 overflow-hidden"
              variants={itemVariants}
            >
              <div className="grid md:grid-cols-2 gap-0">
                <motion.div
                  className="relative h-64 md:h-auto overflow-hidden group"
                  whileHover={{ scale: 1.02 }}
                  transition={{ duration: 0.5 }}
                >
                  <img
                    src={SupportImage}
                    alt="Support"
                    className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent" />
                  <div className="absolute bottom-6 left-6 right-6">
                    <h3 className="text-white text-2xl font-bold">vTecherpSoftware</h3>
                    <p className="text-white/80 text-sm">India's Leading Enterprise Solution</p>
                  </div>
                </motion.div>

                <div className="p-8 md:p-10 flex flex-col justify-center">
                  <p className="text-gray-700 leading-relaxed text-lg mb-6">
                    vTecherpSoftware is a comprehensive solution that helps businesses
                    streamline operations, improve efficiency, and make smarter
                    decisions. It integrates all key business functions into a single,
                    unified platform.
                  </p>

                  <div className="space-y-4 mb-6">
                    {[
                      { title: "Process Automation", desc: "Save time and reduce manual work by automating workflows." },
                      { title: "Data Insights", desc: "Analyze customer and business data for better decision-making." },
                      { title: "Enhanced Communication", desc: "Improve collaboration across departments and with customers." },
                      { title: "All-in-One System", desc: "Manage finance, supply chain, HR, manufacturing, and CRM in one place." },
                    ].map((item, idx) => (
                      <motion.div
                        key={idx}
                        initial={{ x: -20, opacity: 0 }}
                        animate={{ x: 0, opacity: 1 }}
                        transition={{ delay: 0.1 * idx }}
                        className="flex items-start gap-3"
                      >
                        <FaCheckCircle className="text-green-500 mt-1 flex-shrink-0 w-5 h-5" />
                        <div>
                          <span className="font-semibold text-gray-800">{item.title}:</span>
                          <span className="text-gray-600 ml-1">{item.desc}</span>
                        </div>
                      </motion.div>
                    ))}
                  </div>

                  <p className="text-gray-600 leading-relaxed mb-8">
                    Our mission is to empower businesses with technology that fosters
                    growth, collaboration, and success in today's competitive market.
                  </p>

                  <motion.button
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 0.98 }}
                    className="self-start bg-gradient-to-r from-blue-500 to-blue-700 hover:from-blue-600 hover:to-blue-800 px-8 py-3.5 rounded-xl text-white font-semibold shadow-lg hover:shadow-xl transition-all duration-300 flex items-center gap-2 group"
                  >
                    <Link to="/about-company">Learn More</Link>
                    <FaArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                  </motion.button>
                </div>
              </div>
            </motion.div>
          </div>
        </motion.div>

        {/* Bottom CTA */}
        <motion.div className="text-center mt-20" variants={itemVariants}>
          <div className="inline-flex flex-col items-center">
            <p className="text-gray-600 mb-6">Ready to transform your business?</p>
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 px-8 py-4 rounded-xl text-white font-semibold shadow-lg hover:shadow-xl transition-all duration-300"
            >
              <Link to="/book-demo-section" className="flex items-center gap-2">
                Get a Free Demo
                <FaArrowRight className="w-4 h-4" />
              </Link>
            </motion.button>
          </div>
        </motion.div>
      </div>
    </motion.section>
  );
};

export default About;
